import React from "react";
import { Palette } from "lucide-react";
import { useThemeStore } from "../../stores/themeStore";

export const ThemeSwitcher: React.FC<{ className?: string }> = ({ className = "" }) => {
  const { theme, toggleNextTheme } = useThemeStore();

  const themeLabels: Record<string, string> = {
    dark: "Dark Party",
    light: "Light",
    funky: "Neon Funky",
    halloween: "Halloween",
  };

  return (
    <button
      onClick={toggleNextTheme}
      title={`Theme: ${themeLabels[theme]} (Click to switch)`}
      className={`p-2 rounded-xl bg-card border border-border hover:border-primary text-text-muted hover:text-primary transition-all duration-200 cursor-pointer flex items-center gap-1.5 text-xs font-medium ${className}`}
    >
      <Palette className="w-4 h-4" />
      <span className="hidden sm:inline capitalize">{themeLabels[theme]}</span>
    </button>
  );
};
